// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","copyrightLink":"Footer_copyrightLink__FJRDR","textmarginBottom":"Footer_textmarginBottom__9oro0","textmarginTop":"Footer_textmarginTop__Reu4O"};